export const kidsClothings = [ 
    {
    id: 0,
    name: 'Baby polo shirt',
    price: 19.99,
    image: './asset/baby-polo-shirt.png'
    },
    {
    id: 1,
    name: 'Crew neck tshirt',
    price: 19.99,
    image: './asset/crew-neck-t-shirt-01.png'
    },
    {
     id: 2,
     name: 'Hoodie1',
    price: 29.99,
    image: './asset/hoodie-01.png'
    },
    {
    id: 3,
    name: 'Hoodie2',
    price: 29.99,
    image: './asset/hoodie-02.png'
    },
    {
     id: 4,
     name: 'Hoodie3',
    price: 29.99,
     image: './asset/hoodie-03.png'
    },
    {
     id: 5,
    name: 'Lsleeve tshirt1',
    price: 19.99,
    image: './asset/long-sleeve-t-shirt-01.png'
    },
    {
    id: 6,
    name: 'Lsleeve tshirt2',
    price: 19.99,
    image: './asset/long-sleeve-t-shirt-02.png'
    },
    {
    id: 7,
    name: 'Polo white',
    price: 29.99,
    image: './asset/polo-shirt-01.png'
    },
    {
    id: 8,
    name: 'Tank top',
    price: 19.99,
    image: './asset/tank-top-t-shirt-01.png'
    },
     {
     id: 9,
     name: 'V-neck tshirt',
     price: 29.99,
     image: './asset/v-neck-t-shirt-01.png'
    }
]